// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Helpdesk = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Helpdesk = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Helpdesk = _exports.Helpdesk = function Helpdesk(props) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M.482 3.474c1.339-.89 3.11-1.41 5.017-1.41 1.672 0 3.238.4 4.5 1.097 1.263-.697 2.829-1.096 4.5-1.096 1.91 0 3.68.52 5.018 1.41.26.172.418.465.418.778v13a.935.935 0 0 1-1.453.779c-.997-.663-2.398-1.097-3.982-1.097s-2.986.434-3.983 1.097a.94.94 0 0 1-1.035 0c-.997-.663-2.399-1.097-3.983-1.097-1.583 0-2.985.434-3.982 1.097a.935.935 0 0 1-1.453-.78v-13c0-.312.157-.605.418-.778m1.452 1.307v10.94a9.7 9.7 0 0 1 3.565-.656c1.672 0 3.238.399 4.5 1.096 1.263-.697 2.829-1.096 4.5-1.096 1.281 0 2.499.234 3.565.656V4.781c-.954-.52-2.19-.846-3.565-.846-1.583 0-2.985.434-3.982 1.097a.94.94 0 0 1-1.035 0c-.997-.663-2.399-1.097-3.983-1.097-1.373 0-2.61.327-3.565.846",
      clipRule: "evenodd"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10.001 3.844c.517 0 .935.418.935.935v11.335a.935.935 0 1 1-1.87 0V4.779c0-.517.419-.935.935-.935",
      clipRule: "evenodd"
    }));
  };
});
